import { useStoreSupplyTimeline } from '@gozoki/api'
import { useState } from 'react'
import { SupplyDetailModal } from './SupplyDetailModal'
import { SupplyChart } from '@gozoki/ui/components/supply/supply-chart'
import { ChevronRightRoundIcon, LayerIcon } from './icons/LayerIcon'
import { SupplyLegend } from './SupplyLegend'

// Cotes de la maquette (Figma 10715:60134), exprimées dans le canvas logique 1600 × 900 du
// dashboard : la mise à l'échelle vers le 3840 × 2160 est faite une seule fois par HomePage.
// Le bloc « ALL CHART » du Figma fait 253 px ; il englobe la ligne d'en-tête des bandes (pastille
// du jour), qui vit hors de la hauteur passée au graphe — d'où les 32 px retirés ici.
const BAND_HEADER_HEIGHT = 32
const CHART_BLOCK_HEIGHT = 253
const CHART_HEIGHT = CHART_BLOCK_HEIGHT - BAND_HEADER_HEIGHT

export function FluxSupplyCard() {
  const { data, isLoading } = useStoreSupplyTimeline({ days: 7 })
  const [isDetailOpen, setIsDetailOpen] = useState(false)

  return (
    <div className="flex min-w-0 flex-col gap-[16px] overflow-hidden rounded-[24px] bg-[#F0EDE2] p-[17px]">
      <div className="flex h-[40px] items-center gap-[12px]">
        <div className="flex shrink-0 items-center gap-[8px]">
          <span className="flex size-[40px] items-center justify-center rounded-[12px] bg-[#F9F8F1] text-[#4F6A47]">
            <LayerIcon />
          </span>
          <h2 className="font-brand text-[22px] leading-[26px] font-semibold whitespace-nowrap text-[#4F6A47] uppercase">
            Flux supply en temps réel
          </h2>
        </div>

        <button
          type="button"
          aria-label="Ouvrir le détail du flux supply"
          onClick={() => setIsDetailOpen(true)}
          className="shrink-0 cursor-pointer text-[#4F6A47]"
        >
          <ChevronRightRoundIcon />
        </button>

        <span className="h-px min-w-0 flex-1 bg-[#0000000F]" />

        <SupplyLegend />
      </div>

      {data ? (
        <div className="min-w-0">
          <SupplyChart data={data} showAlerts variant="store" height={CHART_HEIGHT} />
        </div>
      ) : (
        <div
          className="flex items-center justify-center text-sm text-[#8A8676]"
          style={{ height: CHART_BLOCK_HEIGHT }}
        >
          {isLoading ? 'Chargement…' : 'Aucune donnée'}
        </div>
      )}

      {isDetailOpen ? <SupplyDetailModal onClose={() => setIsDetailOpen(false)} /> : null}
    </div>
  )
}
